module.exports = __webpack_public_path__ + "static/img/brand-14.4d3e2d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-14.png
// module id = o07d
// module chunks = 0